import axios from "axios";

//const TokenStr = "123456789"; process.env.tokenStr;
const Baseurl = process.env.REACT_APP_base_url;

var RestService = {
  pmsEnquiryData(callback, formdata) {
    axios
      .request({
        url: `${Baseurl}Enquiry/pmsEnquiry`,
        method: "POST",
        data: formdata,
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
      });
  },
  expertEnquiryData(callback, formdata) {
    axios
      .request({
        url: `${Baseurl}Enquiry/expertEnquiry`,
        method: "POST",
        data: formdata,
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
      });
  },
  verifiedMobile(callback, formdata) {
    axios
      .request({
        url: `${Baseurl}Enquiry/webinarEnquiry`,
        method: "POST",
        data: formdata,
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
      });
  },
  getWebinar(callback, formdata) {
    axios
      .request({
        url: `${Baseurl}Enquiry/getWebinar`,
        method: "POST",
        data: formdata,
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
      });
  },
  getWebinarDetail(callback, formdata) {
    axios
      .request({
        url: `${Baseurl}Enquiry/getWebinarDetail`,
        method: "POST",
        data: formdata,
      })
      .then(function (response) {
        callback(JSON.stringify(response));
      })
      .catch(function (error) {
        callback(JSON.stringify(error?.response));
      });
  },
};

export default RestService;
